import styled from 'styled-components';

const DotContainer = styled.div`
  width: max-content;
  cursor: pointer;
`;

const Dot = styled.div`
  width: 8px;
  height: 8px;
  background: black;
  border-radius: 50%;
  margin-bottom: 2px;
`;

const Options = styled.div`
  z-index: 1;
  position: absolute;
  top: 0;
  right: -5px;
  background: white;
  box-sizing: border-box;
  padding: 10px;
  box-shadow: 0px 0px 5px lightgrey;

  & > * {
    cursor: pointer;
    padding: 5px;
    box-sizing: border-box;

    &:hover {
      background: lightgrey;
    }
  }
`;

interface ActionsControleProps {
  collapsed: boolean;
  setCollapsed?(value: boolean): void;
  children: any;
}

export default function ActionsControle({
  collapsed,
  setCollapsed,
  children,
}: ActionsControleProps) {
  if (!collapsed)
    return (
      <DotContainer
        onClick={() => {
          if (!setCollapsed) return;
          setCollapsed(true);
        }}
      >
        <Dot />
        <Dot />
        <Dot />
      </DotContainer>
    );

  return (
    <Options
      onMouseLeave={() => {
        if (!setCollapsed) return;
        setCollapsed(false);
      }}
    >
      {children}
    </Options>
  );
}
